import { Pagination, Space } from '@mantine/core'
import { memo } from 'react'
import { useRecoilState } from 'recoil'

import { TableAtom } from '../recoil/atoms'
import PagingIndicator from './PagingIndicator'
import RankingTable from './RankingTable'

interface TableWithPaginationProps {
  name: string
  labels: string[]
  unSortableIndex: number[]
  rightAlignedColumns?: number[]
  elements: (number | string)[][]
  pageSize: number
  total: number
  columnWidths?: string[]
}

// disp-h = 40 + 16 +  , disp-h-loading = 40 + min-h-[33vh]
const TableWithPagination = memo(
  ({ name, unSortableIndex = [], rightAlignedColumns = [],labels, elements, pageSize, total, columnWidths = [] }: TableWithPaginationProps) => {
    const [tableOpt, setTableOpt] = useRecoilState(TableAtom(name))
    const start = (tableOpt.current - 1) * pageSize
    const end = start + pageSize > total ? total : start + pageSize

    return (
      <>
        <PagingIndicator length={total} pageStart={start} pageEnd={end} />
        <RankingTable
          name={name}
          labels={labels}
          unSortableIndex={unSortableIndex}
          rightAlignedColumns={rightAlignedColumns}
          elements={elements}
          current={tableOpt.current}
          pageSize={pageSize}
          columnWidths={columnWidths}
        />
        {elements && elements.length > 0 && (
          <div className='absolute mt-4 right-4 bottom-4'>
            <Pagination
              total={Math.ceil(total / pageSize)}
              size='xs'
              withEdges
              value={tableOpt.current}
              onChange={(val) => setTableOpt((prev) => ({ ...prev, current: val }))}
            />
          </div>
        )}
        <Space h={50} />
      </>
    )
  },
)

export default TableWithPagination